import { z } from 'zod';
import { ContactIdSchema, EmailSchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
export const ContactRoleSchema = z.enum([
    'primary',
    'billing',
    'technical',
    'executive_sponsor',
    'other',
]);
export const NotificationConsentSchema = z.object({
    consented: z.boolean(),
    consentedAt: IsoTimestampSchema,
    source: z.enum(['opt_in_form', 'verbal', 'inherited_from_msa']),
});
export const ContactSchema = z.object({
    id: ContactIdSchema,
    type: z.literal('contact'),
    schemaVersion: SchemaVersionSchema,
    accountId: IDSchema,
    name: z.string().min(1).max(200),
    email: EmailSchema.optional(),
    emailNormalized: z.string().optional(),
    phone: z.string().optional(),
    title: z.string().optional(),
    role: ContactRoleSchema,
    isActive: z.boolean().default(true),
    // T3-014C — At most ONE contact per account may have isPrimary=true
    // (enforced via partial unique index in migration 0011). Quote PDF
    // PREPARED FOR block selects this contact via findPrimaryByAccountId.
    isPrimary: z.boolean().default(false),
    notificationConsent: NotificationConsentSchema.optional(),
    // RIG-234 — free-text notes (LinkedIn, family info, birthdays, etc.).
    notes: z.string().optional(),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    /** QA 2026-10-01 F-42: deleted together with its account (restore brings it back). */
    deletedByCascade: z.boolean().default(false),
    version: z.number().int().positive(),
});
//# sourceMappingURL=contact.js.map